import { Api } from "api";
import { CreateTabPayload, UpdateTabPayload } from "types/tab-types";

const BASE = "/mini_apps/v1/admin/tabs";

export const getTabs = async (search: URLSearchParams, page?: number) => {
  const params = search ? `?${search}` : "";
  const res = await Api.get(`${BASE}/list${params}`, {
    params: { page },
  });
  return res.data;
};

export const getTabById = async (id: string) => {
  const res = await Api.get(`${BASE}/${id}`);
  return res.data;
};

export const createTab = async (payload: CreateTabPayload) => {
  const res = await Api.post(`${BASE}/`, payload);
  return res.data;
};

export const updateTab = async (id: string, payload: UpdateTabPayload) => {
  const res = await Api.put(`${BASE}/${id}`, payload);
  return res.data;
};

export const deleteTab = async (id: string) => {
  const res = await Api.delete(`${BASE}/${id}`);
  return res.data;
};
